<div class="plan-history">
  <button
    mat-flat-button
    class="back-button plan-history__back-button"
    (keydown.enter)="goBack()"
    (keydown.space)="goBack()"
    (click)="goBack()">
    <span class="odilo-icon" aria-hidden="true">navigate_before</span>
    <span>{{ 'common.back' | translate }}</span>
  </button>

  <div class="plan-history__header">
    <div class="info">
      <h2 class="info__title">{{ careerPlanLabel | translate }}</h2>
      <h2 class="info__name">{{ careerPlan.name }}</h2>
    </div>
  </div>

  <div class="plan-history__finish-date">
    <span class="label">{{ 'careerPlans.finish.date' | translate }}</span>
    <span class="date">{{ careerPlan.finishDate | date }}</span>
  </div>
  <div class="plan-history__skills">
    <app-skills-row *ngFor="let skillsRow of skillRows" [skills]="skillsRow"></app-skills-row>
  </div>
</div>
